
const getAuthorization = () => {
  return "mockup";
}

const local = "en-US";

const LANG_MAP = {
  "en-US": "en",
  "zh-CN": "zh-CN",
  "zh-HK": "zh-TW",
};
export const EXTRA_CKEDITOR_FONTS = [
  "Arial/arial",
  "Raleway/'Raleway', sans-serif",
  "Noto Sans KR/'Noto Sans KR', sans-serif",
  "Malgun Gothic/Malgun Gothic",
  "Calibri/Calibri",
  "Corbel/corbel",
  "PingFang SC/PingFangSC-Regular",
  "宋體/SimSun",
  "黑體/SimHei",
  "微軟雅黑/Microsoft YaHei",
  "微軟正黑體/Microsoft JhengHei",
  "楷體/KaiTi",
  "新宋體/NSimSun",
  "仿宋/FangSong",
  "新細明體/PMingLiU",
  "細明體/MingLiU",
  "華文黑體/STHeiti",
  "華文楷體/STKaiti",
  "華文宋體/STSong",
  "華文仿宋/STFangsong",
  "華文中宋/STZhongsong",
  "華文琥珀/STHupo",
  "華文新魏/STXinwei",
  "華文隸書/STLiti",
  "華文行楷/STXingkai",
  "冬青黑體/Hiragino Sans GB",
  "蘭亭黑-繁/Lantinghei TC",
  "蘭亭黑-簡/Lantinghei SC",
  "翩翩體-繁/Hanzipen TC",
  "翩翩體-簡/Hanzipen SC",
  "手札體-繁/Hannotate TC",
  "手札體-簡/Hannotate SC",
  "宋體-繁/Songti TC",
  "宋體-簡/Songti SC",
  "娃娃體-繁/Wawati TC",
  "娃娃體-簡/Wawati SC",
  "魏碑-繁/Weibei TC",
  "魏碑-簡/Weibei SC",
  "行楷-繁/Xingkai TC",
  "行楷-簡/Xingkai SC",
  "雅痞-繁/Yapi TC",
  "雅痞-簡/Yapi SC",
  "圓體-繁/Yuanti TC",
  "圓體-簡/Yuanti SC",
].join(";");

export const CKCONFIG = {
  language: LANG_MAP[local],
  removeButtons:
    "Flash,Blockquote,CreateDiv,Smiley,Iframe,Styles,Format,Anchor,SpecialChar,PageBreak,HorizontalRule",
  removePlugins: "magicline",
  extraPlugins: "mergetags",
  font_names: EXTRA_CKEDITOR_FONTS,
  toolbarGroups: [
    { name: "editing", groups: ["basicstyles"] },
    { name: "paragraph", groups: ["blocks", "align", "indent", "paragraph", "list"] },
    "/",
    { name: "styles", groups: ["styles"] },
    { name: "colors", groups: ["colors"] },
    { name: "links", groups: ["links", "mergetags"] },
  ],
};


export const FREE_TEXT_CKCONFIG = {
  language: LANG_MAP[local],
  removeButtons:
    "Flash,Blockquote,CreateDiv,Smiley,Iframe,Styles,Format,Anchor,SpecialChar,PageBreak,HorizontalRule",
  removePlugins: "magicline",
  toolbarGroups: [
    { name: "editing", groups: ["basicstyles"] },
    { name: "styles", groups: ["styles"] },
    { name: "colors", groups: ["colors"] },
    { name: "links", groups: ["links"] },
  ],
};
